/* prettier-ignore */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { HeaderComponent } from './header/header.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { createTranslateLoader } from '../app.module';
import { HttpClient } from '@angular/common/http';
import { ScrollCardModule } from '../directives/scroll-card/scroll-card.module';
import { ListCardsComponent } from './list-cards/list-cards.component';
import { ListEventsComponent } from './list-events/list-events.component';
import { GenericCardComponent } from './generic-card/generic-card.component';
import { PDFViewerComponentModule } from './pdf-viewer/pdf-viewer.module';
import { GoogleMapsPlacesComponent } from './google-maps-places/google-maps-places.component';
import { RegistersAfterBeforeComponent } from './registers-after-before/registers-after-before.component';
import { RouteCardComponent } from './route-card/route-card.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LazyImageComponent } from './lazy-image/lazy-image.component';
import { ListRoutesComponent } from './list-routes/list-routes.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { ScheduleComponent } from '../pages/home/components/schedule/schedule.component';
import { CalendarCardComponent } from '../pages/home/components/schedule/calendar-card/calendar-card.component';
import { UiScrollModule } from 'ngx-ui-scroll';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { GoogleTranslateComponent } from './google-translate/google-translate.component';
import { SelectGoogleLanguageComponent } from './select-google-lang/select-google-lang.component';
import { RegistersCalendarComponent } from './registers-components/step-calendar/step-calendar.component';
import { RegisterTravelerTypeComponent } from './registers-components/step-traveler-type/step-traveler-type.component';
import { RegisterInterestTypeComponent } from './registers-components/step-interest-type/step-interest-type.component';
import { RegisterSubInterestTypeComponent } from './registers-components/step-interest-type/sub-interest-type/sub-interest-type.component';
import { FavouriteIconComponent } from './icons/favourite.component';
import { TimeIconComponent } from './icons/time.component';
import { OfferIconComponent } from './icons/offer.component';
import { HeaderUserMenuComponent } from './header/components/user/user.component';
import { HeaderLanguagesComponent } from './header/components/languages/languages.component';
import { HeaderTechUpdateRouteComponent } from './header/components/tech-update-route/tech-update-route.component';
import { HeaderTechExitComponent } from './header/components/tech-exit/tech-exit.component';
import { PassportIconComponent } from './icons/passport.component';
import { SwiperModule } from 'swiper/angular';
import { ListHikingComponent } from './list-hiking/list-hiking.component';

@NgModule({
 declarations: [
    HeaderComponent,
    CalendarCardComponent,
    ListCardsComponent,
    GenericCardComponent,
    ListEventsComponent,
    ListHikingComponent,
    LazyImageComponent,
    RegistersAfterBeforeComponent,
    LoginComponent,
    RouteCardComponent,
    ListRoutesComponent,
    RegisterComponent,
    ScheduleComponent,
    GoogleTranslateComponent,
    SelectGoogleLanguageComponent,
    RegistersCalendarComponent,
    RegisterTravelerTypeComponent,
    RegisterInterestTypeComponent,
    RegisterSubInterestTypeComponent,
    FavouriteIconComponent,
    TimeIconComponent,
    OfferIconComponent,
    HeaderUserMenuComponent,
    HeaderLanguagesComponent,
    HeaderTechUpdateRouteComponent,
    HeaderTechExitComponent,
 ],
 imports: [
   CommonModule,
   IonicModule,
   GoogleMapsPlacesComponent,
   ScrollCardModule,
   NgSelectModule,
   MatCardModule,
   UiScrollModule,
   MatDatepickerModule,
   LazyLoadImageModule,
   SwiperModule,
   RouterModule,
   PDFViewerComponentModule,
   ReactiveFormsModule,
   FormsModule,
   PassportIconComponent,
   TranslateModule.forChild({
      loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient]
      }
    })
 ],
 exports: [
    HeaderComponent,
   //  BannerInstallAPPComponent,
    ListCardsComponent,
    GenericCardComponent,
    ListEventsComponent,
    ListHikingComponent,
    RegistersAfterBeforeComponent,
    LoginComponent,
    RegisterComponent,
    LazyImageComponent,
    NgSelectModule,
    GoogleMapsPlacesComponent,
    CalendarCardComponent,
    RouteCardComponent,
    ListRoutesComponent,
    ScheduleComponent,
    GoogleTranslateComponent,
    SelectGoogleLanguageComponent,
    RegistersCalendarComponent,
    RegisterTravelerTypeComponent,
    RegisterInterestTypeComponent,
    RegisterSubInterestTypeComponent,
    FavouriteIconComponent,
    TimeIconComponent,
    OfferIconComponent,
    HeaderUserMenuComponent,
    HeaderLanguagesComponent,
    HeaderTechUpdateRouteComponent,
    HeaderTechExitComponent,
    PassportIconComponent
 ]
})

export class SharedModule { }